import { getToken, storeToken } from 'helper/common';
import agent from '../../../service/agent';
import {
    LOGIN_ERROR,
    LOGIN_ERROR_CLEAR,
    LOGIN_PENDING,
    LOGIN_SUCCESS,
    LOGIN_USER_PROFILE,
    PROFILE_ERROR,
    PROFILE_ERROR_CLEAR,
    PROFILE_PENDING,
    USER_LOGOUT,
} from "./constants";
import { openSnackbar } from 'store/slices/snackbar';
import { trimmedValues } from 'helper/trim';

export const logoutUser = () => (dispatch) => {
    dispatch({ type: USER_LOGOUT });
};

export const loginPending = () => ({
    type: LOGIN_PENDING
})
export const loginError = (errorMessage) => ({
    type: LOGIN_ERROR,
    payload: { errorMessage }
})
export const loginErrorClear = () => ({
    type: LOGIN_ERROR_CLEAR
})
export const loginSuccess = () => ({
    type: LOGIN_SUCCESS
})
export const setProfile = (profile) => ({
    type: LOGIN_USER_PROFILE,
    payload: { profile },
})

export const userLogin = (formData) => (dispatch) => {
    const dataToSend = trimmedValues({ ...formData })
    dispatch(loginPending());
    return agent.authentication.login(dataToSend)
        .then((data) => {
            const { accessToken } = data || {};
            storeToken(data);
            return agent.authentication.profile(accessToken)
                .then((response) => {
                    dispatch(loginSuccess());
                    dispatch(setProfile(response));
                    dispatch(openSnackbar({
                        open: true,
                        message: ':) Logged in successfully.',
                        variant: 'alert',
                        close: false
                    }))
                })
                .catch((err) => {
                    console.log(err)
                    if (err && err.status === 400) {
                        dispatch(loginError(err.response && err.response.text))
                    }
                    else {
                        dispatch(loginError(":( Network Error"));
                    }
                    dispatch(openSnackbar({
                        open: true,
                        message: 'Something went wrong. Try again.',
                        variant: 'alert',
                        close: false
                    }))
                })
        })
        .catch((err) => {
            console.log(err)
            if (err && err.status === 400) {
                dispatch(loginError(err.response && err.response.text))
            }
            else {
                dispatch(loginError(":( Network Error"));
            }
            dispatch(openSnackbar({
                open: true,
                message: 'Something went wrong. Try again.',
                variant: 'alert',
                close: false
            }))
        })
}

export const profilePending = () => ({
    type: PROFILE_PENDING
})
export const profileError = (errorMessage) => ({
    type: PROFILE_ERROR,
    payload: { errorMessage }
})
export const profileErrorClear = () => ({
    type: PROFILE_ERROR_CLEAR
})

export const getProfile = () => (dispatch) => {
    dispatch(profilePending());
    return getToken(dispatch).then((accessToken) => {
        return agent.authentication.profile(accessToken)
            .then((response) => {
                dispatch(setProfile(response));
                dispatch(profileErrorClear());
            })
            .catch((err) => {
                console.log(err)
                if (err && err.status === 400) {
                    dispatch(profileError(err.response && err.response.text))
                }
                else {
                    dispatch(profileError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}